export const ORIGIN = {
  SHIFT: 'shift',
  STAMPS: 'stamps',
  STAMPS_WITH_SHIFT: 'stampsWithShift',
};
